/**
 * @generated SignedSource<<d3d953e098b84910372508f2b96209a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanySupportEmail_company$data = {
  readonly preferences: {
    readonly support: {
      readonly email: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentCompanySupportEmail_company";
};
export type PaymentCompanySupportEmail_company$key = {
  readonly " $data"?: PaymentCompanySupportEmail_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupportEmail_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanySupportEmail_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesSupport",
          "kind": "LinkedField",
          "name": "support",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "2a5624fa6dbffd7184073f13585af879";

export default node;
